import { useNavigate } from "react-router-dom";
import HeaderBar from "../../../Components/UI/headerbar";
import ShippingsTab from "../../../Components/shipping/ShippingsTab";

const ShippingCompaniesPage = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
        navigate(`${process.env.PUBLIC_URL}/shipping/store-shippings`);
  };

  return (
    <div className="container-fluid">
      <HeaderBar
        title={"التوصيل"}
        content={
          "إدارة شركات الشحن المرتبطة بالنظام، يمكنك عرض بيانات الشركات والسائقين المرتبطين بهم."
        }
      />
      <ShippingsTab onAddClick={handleNavigate} />
    </div>
  );
};

export default ShippingCompaniesPage;
